import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'areaTrash/state',
    initialState: {
        deleteConfirmation: false,
        recoverConfirmation: false,
        selectedArea: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        toggleRecoverConfirmation: (state, action) => {
            state.recoverConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedArea: (state, action) => {
            state.selectedArea = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation,
    toggleRecoverConfirmation,
    setSortedColumn,
    setSelectedArea
} = stateSlice.actions

export default stateSlice.reducer
